import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import useCurrentUser from '../../../hooks/useCurrentUser'
import ActiveSubscriptions from './ActiveSubscriptions'
import AvailableSubscriptions from './AvailableSubscriptions'
import Settings from './Settings'

const Subscriptions = ({location})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const isOwner = (
		parseInt(user.gym_id) !== 0
		? user.account_type === 'gym'
		: user.account_type === 'trainer'
	)

	
	return (
		<div style={{height:'100%',overflow:'auto'}}>
			<Tabs defaultActiveKey="available" id="subscription-tabs" className="mb-3">
				<Tab 
					title={isClient?"Available Subscriptions":"Manage Subscriptions"}
					eventKey="available" 
				>
					<AvailableSubscriptions/>
				</Tab>
				<Tab eventKey="active" title="Active Subscriptions">
					<ActiveSubscriptions/>
				</Tab>
				{isOwner&&
					<Tab eventKey="settings" title="Settings">
						<Settings/>
					</Tab>
				}
			</Tabs>
		</div>
	)
}

export default Subscriptions